// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__js1Iq","containerItemsCenter":"Skeleton_containerItemsCenter__T-muj"};